// VERSION 1.0.0
// AUTHOR: AGALYA

import { all, call, put, takeLatest } from 'redux-saga/effects';
import TransferCenterActionTypes from './transfer-center.types';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	createTransferLogFailure,
	createTransferLogResponseChanged,
	createTransferLogSuccess,
	fetchTransferCenterDetailsFailure,
	fetchTransferCenterDetailsResponseChanged,
	fetchTransferCenterDetailsSuccess,
	fetchTransferGroupDetailsFailure,
	fetchTransferGroupDetailsResponseChanged,
	fetchTransferGroupDetailsSuccess,
	createCenterTransferFailure,
	createCenterTransferResponseChanged,
	createCenterTransferSuccess,
} from './transfer-center.action';
import {
	createTransferCneterData,
	fetchTransferCenterData,
	fetchTransferGroupData,
	createCenterTransferData,
} from './transfer-center.service';

/*************** CREATE TRANSFER LOG START  ******************/
export function* createTransferDetails({ payload }: any) {
	try {
		const {
			loanIndexArr,
			memList,
			fromBranchID,
			fromCenterID,
			fromGroupID,
			funderID,
			groupOfficerID,
			precloseDate,
			toCenterID,
			toBranchID,
			toGroupID,
			transferBranchUniqueID,
			transferByUserID,
			transferID,
			transferLogType,
			transferType,
			uniqueTransferID,
			userID,
			isMemberWiseFunder,
			isTransferWithInterest,
			companyID,
			databaseName,
		} = payload;
		const key = 'CreateTransferCenterLogKey';
		const jsonData = {
			LoanIndexArr: loanIndexArr,
			MemList: memList,
			FromBranchID: fromBranchID,
			FromCenterID: fromCenterID,
			FromGroupID: fromGroupID,
			FunderID: funderID,
			GroupOfficerID: groupOfficerID,
			PrecloseDate: precloseDate,
			ToCenterID: toCenterID,
			ToBranchID: toBranchID,
			ToGroupID: toGroupID,
			TransferBranchUniqueID: transferBranchUniqueID,
			TransferByUserID: transferByUserID,
			TransferID: transferID,
			TransferLogType: transferLogType,
			TransferType: transferType,
			UniqueTransferID: uniqueTransferID,
			UserID: userID,
			isMemberWiseFunder,
			isTransferWithInterest,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createTransferCneterData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createTransferLogFailure(responseData.data));
		} else {
			yield put(createTransferLogSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createTransferLogFailure(error));
	}
}

export function* resetCreateTransferDetailsResponse() {
	yield put(createTransferLogResponseChanged());
}

export function* onCreateTransferDetails() {
	yield takeLatest(TransferCenterActionTypes.CREATE_TRANSFER_LOG_START, createTransferDetails);
}

export function* onCreateTransferDetailsResponseReset() {
	yield takeLatest(
		TransferCenterActionTypes.CREATE_TRANSFER_LOG_RESPONSE_RESET_START,
		resetCreateTransferDetailsResponse,
	);
}
/*************** CREATE TRANSFER LOG END ******************/

/*************** MEMBER CENTER TRANSFER START  ******************/
export function* createCenterTransferDetails({ payload }: any) {
	try {
		const {
			loanIndexArr,
			memList,
			fromBranchID,
			fromCenterID,
			fromGroupID,
			funderID,
			groupOfficerID,
			precloseDate,
			toCenterID,
			toBranchID,
			toGroupID,
			transferBranchUniqueID,
			transferByUserID,
			transferID,
			transferLogType,
			transferType,
			uniqueTransferID,
			userID,
			isMemberWiseFunder,
			isTransferWithInterest,
			companyID,
			databaseName,
		} = payload;
		const key = 'CreateTransferCenterKey';
		const jsonData = {
			LoanIndexArr: loanIndexArr,
			MemList: memList,
			FromBranchID: fromBranchID,
			FromCenterID: fromCenterID,
			FromGroupID: fromGroupID,
			FunderID: funderID,
			GroupOfficerID: groupOfficerID,
			PrecloseDate: precloseDate,
			ToCenterID: toCenterID,
			ToBranchID: toBranchID,
			ToGroupID: toGroupID,
			TransferBranchUniqueID: transferBranchUniqueID,
			TransferByUserID: transferByUserID,
			TransferID: transferID,
			TransferLogType: transferLogType,
			TransferType: transferType,
			UniqueTransferID: uniqueTransferID,
			UserID: userID,
			isMemberWiseFunder,
			isTransferWithInterest,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createCenterTransferData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createCenterTransferFailure(responseData.data));
		} else {
			yield put(createCenterTransferSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createCenterTransferFailure(error));
	}
}

export function* resetCreateCenterTransferResponse() {
	yield put(createCenterTransferResponseChanged());
}

export function* onCreateCenterTransfer() {
	yield takeLatest(
		TransferCenterActionTypes.CREATE_CENTER_TRANSFER_START,
		createCenterTransferDetails,
	);
}

export function* onCreateCenterTransferResponseReset() {
	yield takeLatest(
		TransferCenterActionTypes.CREATE_CENTER_TRANSFER_RESPONSE_RESET_START,
		resetCreateCenterTransferResponse,
	);
}
/*************** MEMBER CENTER TRANSFER END ******************/

/*************** FETCH TRANSFER CENTER START  ******************/
export function* fetchTransferCenterDetails({ payload }: any) {
	try {
		const { databaseName, companyID, transferID } = payload;
		const key = 'FetchParticularTransferCenterKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			TransferID: transferID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchTransferCenterData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchTransferCenterDetailsFailure(responseData.data));
		} else {
			yield put(fetchTransferCenterDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchTransferCenterDetailsFailure(error));
	}
}

export function* resetFetchTransferCenterResponse() {
	yield put(fetchTransferCenterDetailsResponseChanged());
}

export function* onFetchTransferCenter() {
	yield takeLatest(
		TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_START,
		fetchTransferCenterDetails,
	);
}

export function* onFetchTransferCenterResponseReset() {
	yield takeLatest(
		TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_RESPONSE_RESET_START,
		resetFetchTransferCenterResponse,
	);
}
/*************** FETCH TRANSFER CENTER END  ******************/

/*************** FETCH TRANSFER GROUP START  ******************/
export function* fetchTransferGroupDetails({ payload }: any) {
	try {
		const key = 'GetAllGroupsListkey';
		const {
			companyID,
			uniqueGroupID,
			userID,
			userRole,
			userLevel,
			databaseName,
			groupID,
			centerID,
			provisionType,
			locationPinCode,
			branchID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UniqueGroupID: uniqueGroupID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			GroupID: groupID,
			LocationID: centerID,
			ProvisionType: provisionType,
			GroupLocationPinCode: locationPinCode,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchTransferGroupData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchTransferGroupDetailsFailure(responseData.data));
		} else {
			yield put(fetchTransferGroupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchTransferGroupDetailsFailure(error));
	}
}

export function* resetFetchTransferGroupResponse() {
	yield put(fetchTransferGroupDetailsResponseChanged());
}

export function* onFetchTransferGroup() {
	yield takeLatest(
		TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_START,
		fetchTransferGroupDetails,
	);
}

export function* onFetchTransferGroupResponseReset() {
	yield takeLatest(
		TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_RESPONSE_RESET_START,
		resetFetchTransferGroupResponse,
	);
}
/*************** FETCH TRANSFER GROUP END  ******************/

export function* transferCenterSaga() {
	yield all([
		call(onCreateTransferDetails),
		call(onCreateTransferDetailsResponseReset),
		call(onCreateCenterTransfer),
		call(onCreateCenterTransferResponseReset),
		call(onFetchTransferCenter),
		call(onFetchTransferCenterResponseReset),
		call(onFetchTransferGroup),
		call(onFetchTransferGroupResponseReset),
	]);
}
